<div class="flex root">
    <div class="flex row flex-100">
        <input
            type="text"
            class="search"
            #input
            [formControl]="queryControl"
            [matAutocomplete]="auto"
            matInput
            placeholder="Search"
            (keyup)="$event.preventDefault()"
        />
    </div>

    <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="selectHandler($event)"
    >
        @if (results$ | async; as results) {
            @if (results.users.length > 0) {
                @for (user of results.users; track user) {
                    <mat-option [value]="user">
                        <mat-icon>account_box</mat-icon> {{ user.name }}
                    </mat-option>
                }
                <hr />
            }
            @for (tag of results.tags; track tag) {
                <mat-option [value]="tag">
                    <mat-icon>label</mat-icon> {{ tag.displayName }}
                </mat-option>
            }
        }
    </mat-autocomplete>
</div>
